import bridge from "@xpeng/js-bridge";
import { wxInit, myInit, isInApp, getClientEnv } from "./common";
import { getBrowserEnv } from "./tools";

const { isWXApp, isMyApp } = getBrowserEnv();

export interface ShareType {
  shareTitle: string;
  shareDesc: string;
  sharePicUrlAccess: string;
}

/**
 * APP、wx、小程序、骁龙、浏览器内的分享功能处理
 * ---
 * @param shareParam
 * @param shareParam.shareTitle - 分享标题
 * @param shareParam.shareDesc - 分享详情文本
 * @param shareParam.sharePicUrlAccess - 分享icon
 * @param shareUrl -分享url
 * @param posterImageBase64 -如果传该参数，APP则会启用分享海报, 分享的海报图片 base64 格式 需要移除头（比如：function已经处理该头 --->【/^data:image\/(jpeg|png|jpg);base64,/】 如果不一致，需要自己处理 ）
 */

export function simpleShare(
  { shareTitle, shareDesc, sharePicUrlAccess }: ShareType,
  shareUrl: string,
  posterImageBase64?: string,
) {
  console.log("simpleShare", isInApp());

  if (isInApp()) {
    console.log("inAPP");

    if (posterImageBase64) {
      bridge.callHandler("sharePanel", {
        style: 4, // 海报专用分享面板
        addExtInfo: false, // 是否添加二维码等补充
        addUserInfo: false, // 是否添加用户信息
        addQrCode: false,
        data: {
          shareType: 2, // 虽然已经明确是海报分享，还是需要设置分享数据类型为图像
          title: shareTitle,
          content: shareDesc,
          postImage: posterImageBase64.replace(
            /^data:image\/(jpeg|png|jpg);base64,/,
            "",
          ),
        },
      });
    } else {
      console.log("notinAPP");
      bridge
        .callHandler("sharePanel", {
          style: 0,
          data: {
            title: shareTitle,
            content: shareDesc,
            url: encodeURIComponent(shareUrl),
            thumImageUrl: sharePicUrlAccess || "",
            shareType: 3,
          },
        })
        .catch(console.error);
    }
  }
}

export function imgToBase64(url: string, ratio = 1) {
  return new Promise<any>((resolve, reject) => {
    if (url) {
      try {
        let canvas = document.createElement("canvas") as any;
        const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
        let img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = function () {
          console.log("img.onload", img);
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          let dataURL = canvas.toDataURL("image/jpeg", ratio);
          console.log("dataURL", dataURL);
          resolve(dataURL);
          canvas = null;
        };
      } catch (error) {
        console.error("imgToBase64 error", error);
      }
    } else {
      resolve("");
    }
  });
}

// 如果是微信小程序/支付宝小程序，需要设置页面分享信息
export const defineShareInfoInMiniProgram = ({
  shareTitle = "",
  shareIcon = "",
  shareUrl = "",
}) => {
  if (isWXApp) {
    wxInit().then((wx) =>
      wx.miniProgram.postMessage({
        data: { shareTitle, shareIcon, shareUrl },
      }),
    );
  } else if (isMyApp) {
    myInit().then((my) =>
      my.postMessage({
        data: { shareTitle, shareIcon, shareUrl },
      }),
    );
  }
};

//
/**
 * 分享微信小程序
 * ---
 * @param shareMainTitle - 分享标题
 * @param shareSubTitle - 分享副标题
 * @param shareImgUrl - 分享图片
 * @param sharePath - 分享路径 默认当前页面
 *
 * */
export async function shareMiniProgramToWX({
  shareMainTitle,
  shareSubTitle,
  shareImgUrl,
  sharePath = location.href,
}) {
  try {
    const imgBase64 = await imgToBase64(shareImgUrl, 0.5);
    const thumb = imgBase64.split(",")[1] || "";

    let miniprogramType = 2; // 正式版:0，测试版:1，体验版:2
    if (getClientEnv() === "product") {
      miniprogramType = 0;
    }
    const callBridge: any = bridge.callHandler;
    callBridge.call(bridge, "shareMiniProgram", {
      webpageUrl: sharePath,
      miniprogramType,
      userName: "gh_bcdeac2bff9d",
      path: sharePath,
      title: shareMainTitle || "",
      desc: shareSubTitle || "",
      thumb: thumb, // thumbSizeKb && thumbSizeKb <= 128 ? thumb : "" // base64, 小于128k, 不需要base64类型说明头，只需要传原始图片数据
    });
  } catch (error) {
    console.log("shareMiniProgram error-->", error);
  }
}

export async function urlToBase64(url) {
  console.log("urlToBase64", url);
  try {
    const response = await fetch(url);
    console.log("response", url, response);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("转换失败:", error);
  }
}
